<template>
  <div>

        <v-card>
          <v-card-title class="justify-center" style="background-color: #e6e6e6;">
            <v-icon left>mdi-chart-line</v-icon>
            Relatório Quantitativo
          </v-card-title>
          <v-card-text>

            <v-row class="mt-3" dense>
              <v-col cols="6">
                <v-select
                    no-data-text="Nenhuma avaliação encontrada"
                    :loading="carregandoAvaliacoes"
                    :disabled="carregandoAvaliacoes"
                    v-model="avaliacaoSelecionada"
                    :items="avaliacoes"
                    item-text="descricao"
                    item-value="id"
                    label="Avaliação"
                    @change="onChangeAvaliacao"
                    outlined
                    dense
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                    no-data-text="Nenhum Caderno encontrado"
                    :loading="carregandoCadernos"
                    :disabled="carregandoCadernos"
                    v-model="cadernoSelecionado"
                    :items="cadernos"
                    item-text="descricao"
                    item-value="id"
                    label="Caderno"
                    @change="onChangeCaderno"
                    outlined
                    dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row dense class="mt-n4">
              <v-col cols="6">
                <v-select
                    no-data-text="Nenhuma escola encontrada"
                    :loading="carregandoEscola"
                    :disabled="carregandoEscola"
                    v-model="escolaSelecionada"
                    :items="escolas"
                    item-text="nome"
                    item-value="id"
                    label="Escola"
                    @change="onChangeEscola"
                    outlined
                    clearable
                    dense
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                    no-data-text="Nenhuma turma encontrada"
                    :loading="carregandoTurmas"
                    :disabled="carregandoTurmas"
                    v-model="turmaSelecionada"
                    :items="turmas"
                    item-text="turma"
                    item-value="id"
                    label="Turmas"
                    outlined
                    clearable
                    dense
                ></v-select>
              </v-col>

            </v-row>
            <v-row dense class="mt-n4" justify="center">
              <v-btn
                  depressed
                  color="primary"
                  @click="filtrar"
                  :disabled="!avaliacaoSelecionada || !cadernoSelecionado || carregandoRelatorio"
              >
                Filtrar
              </v-btn>
            </v-row>
          </v-card-text>
       </v-card>
    <v-row  v-if="carregandoRelatorio" class="mt-4" justify="center">
      <h2>Carregando...</h2>

    </v-row>
    <v-card v-for="chart in charts" :key="chart.id">
      <highcharts class="mt-4"  :options="chart" />
    </v-card >

  </div>
</template>

<script>
import RelatorioQuantitativoService from "../../../service/RelatorioQuantitativoService";
import {Chart} from "highcharts-vue";
export default {
  components: {
    highcharts: Chart
  },
  data() {
    return {
      avaliacoes: [],
      avaliacaoSelecionada: null,
      cadernos: [],
      cadernoSelecionado: null,
      escolas: [],
      escolaSelecionada: [],
      turmas: [],
      turmaSelecionada: null,
      relatorio: [],
      carregandoAvaliacoes: false,
      carregandoCadernos: false,
      carregandoEscola: false,
      carregandoTurmas: false,
      carregandoRelatorio: false,
      charts: [],
      chartBase: {
        id: 0,
        tooltip: {},
        chart:{
          type: "column"
        },
        title: {
          text: "ASDASD"
        },
        subtitle: {
          text: 'Matematica'
        },
        yAxis: {
          title: {
            text: 'Quantidade'
          },
          min: 0,
          max: 100
        },
        xAxis: {
          title: {
            text: "Avaliação"
          },
          categories: ['0','Acertou', 'Aproximou', 'Errou', 'Zerou'],

        },
        legend: {
          enabled:false
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            },
            pointStart: 1
          }
        },
        series: [{
          name: 'Quantidade',
          data: [],
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
              }
            }
          }]
        }
      }


    }
  },
  methods: {
    onChangeAvaliacao(idAvaliacao) {
      this.cadernos = [];
      this.cadernoSelecionado = null;
      this.escolas = [];
      this.escolaSelecionada = null;
      this.turmas = [];
      this.turmaSelecionada= null;
      this.carregandoCadernos = true;
      RelatorioQuantitativoService.getCadernos(idAvaliacao)
          .then(result => {
            console.log(result.data);
            this.cadernos = result.data;
          })
          .finally(() => {
            this.carregandoCadernos = false;
          })
    },
    onChangeCaderno() {
      this.escolas = []
      this.escolaSelecionada = null;
      this.turmas = []
      this.turmaSelecionada= null;
      this.carregandoEscola = true;
      RelatorioQuantitativoService.getEscolas(this.avaliacaoSelecionada, this.cadernoSelecionado)
          .then(result => {
            this.escolas = result.data;
          }).finally(() => {
            this.carregandoEscola = false;
      })
    },
    onChangeEscola() {
      this.turmas = [];
      this.turmaSelecionada= null;
      this.carregandoTurmas = true;
      RelatorioQuantitativoService.getTurmas(this.avaliacaoSelecionada, this.cadernoSelecionado, this.escolaSelecionada)
          .then(result => {
            console.log(result.data);
            this.turmas = result.data;
          })
          .finally(() => {
            this.carregandoTurmas = false;
          })
    },
    filtrar() {
      this.charts = []
      this.carregandoRelatorio = true;
      RelatorioQuantitativoService.getRelatorio(this.avaliacaoSelecionada, this.cadernoSelecionado, this.escolaSelecionada, this.turmaSelecionada)
          .then(result => {
            result.data.forEach(r => {
              let newChart = JSON.parse(JSON.stringify(this.chartBase));
              newChart.id = r.numero
              newChart.yAxis.max = Math.max(...[r.quantidadeAcertos, r.quantidadeAproximou, r.quantidadeErros, r.quantidadeZerou])
              newChart.series[0].data.push(this.addData(r.quantidadeAcertos,'Acertou', '#0fa82b'));
              newChart.series[0].data.push(this.addData(r.quantidadeAproximou, 'Aproximou', '#d4d420'));
              newChart.series[0].data.push(this.addData(r.quantidadeErros,'Errou', '#c91821'));
              newChart.series[0].data.push(this.addData(r.quantidadeZerou,'Zerou', '#82827e'));
              newChart.title.text = 'Questão número ' + r.numero;
              newChart.subtitle.text = r.descricao
              newChart.tooltip.formatter = function () {
                return `<div style="margin-left: 5px; margin-right: 5px;">
                        <h3>${this.point.descricao}</strong></h3>
                        <br />
                        <h3>${this.point.y}</strong></h3>
                     </div>`
              }
              this.charts.push(newChart)
            });
          }).finally(() => {
            this.carregandoRelatorio = false;
      })
    },

    addData(quantidade, descricao, color) {
      let tooltipData = {
        y: Math.round(quantidade),
        descricao: descricao,
        color: color
      }
      return tooltipData;
    },
  },
  created() {
    this.carregandoAvaliacoes = true;
    RelatorioQuantitativoService.getAvaliacoes()
        .then(result => {
          console.log(result.data);
          this.avaliacoes = result.data;
        })
        .finally(()=> {
          this.carregandoAvaliacoes = false;
        })
  }
}

</script>